import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { CompaniesAbstract } from '@companies/abstract/companies-abstract';
import { addCompany } from '@companies/store/companies.actions';
import { RestCompanyModel } from '@shared/interfaces/companies.interface';

@Component({
  selector: 'app-add-new-company-modal',
  templateUrl: './add-new-company-modal.component.html',
  styleUrls: ['./add-new-company-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddNewCompanyModalComponent extends CompaniesAbstract implements OnInit {
  form: UntypedFormGroup;

  constructor(
    protected cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<AddNewCompanyModalComponent>,
    private store: Store<{}>,
    private formBuilder: UntypedFormBuilder
  ) {
    super(cdr);
  }

  get displayName(): UntypedFormControl {
    return this.form.get(this.CompanyForm.DISPLAY_NAME) as UntypedFormControl;
  }

  get legalName(): UntypedFormControl {
    return this.form.get(this.CompanyForm.LEGAL_NAME) as UntypedFormControl;
  }

  ngOnInit(): void {
    this.initForm();
  }

  cancel() {
    this.dialogRef.close(null);
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.cdr.detectChanges();
      return;
    }

    const companyModel: RestCompanyModel = {
      id: 0,
      displayName: this.displayName.value,
      legalName: this.legalName.value,
      contactPersonId: 0,
      employees: [],
      addresses: [],
    };

    this.store.dispatch(addCompany({ companyModel }));
    this.dialogRef.close(null);
  }

  private initForm() {
    this.form = this.formBuilder.group({
      [this.CompanyForm.DISPLAY_NAME]: [null, [Validators.required]],
      [this.CompanyForm.LEGAL_NAME]: [null, [Validators.required]],
    });
  }
}
